import React, { useState } from "react";

const DeleteFilteredPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showDeleteFilteredPopup, setShowDeleteFilteredPopup] =
      useState<boolean>(false);

    const deleteFilteredToggleHandler = () => {
      setShowDeleteFilteredPopup(!showDeleteFilteredPopup);
    };

    return (
      <Component
        showDeleteFilteredPopup={showDeleteFilteredPopup}
        deleteFilteredToggleHandler={deleteFilteredToggleHandler}
        {...props}
      />
    );
  };

export default DeleteFilteredPopupHOC;
